<template>
  <a-modal
    :visible="visible"
    :title="null"
    :closable="false"
    width="100%"
    :footer="null"
    :zIndex="zIndex"
    :get-container="getContainer"
    wrap-class-name="pdf-preview-flat-modal"
    @cancel="close"
  >
    <div class="pdf-preview-shell">
      <div class="pdf-preview-header">
        <div class="pdf-preview-title">{{ title }}</div>
        <button class="pdf-preview-close" type="button" @click="close">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="pdf-preview-body">
        <i
          v-if="loading"
          class="fa fa-spinner spin fa-3x text-white pdf-preview-spinner"
        ></i>
        <iframe
          v-if="src && !loading"
          ref="iframe"
          :src="src"
          class="pdf-preview-flat-iframe"
          @load="printIframe"
        ></iframe>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'PreInvoiceV2PdfPreviewModal',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    src: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    zIndex: { type: Number, default: 2000 },
    autoPrint: { type: Boolean, default: false }
  },
  data() {
    return {
      printedSrc: null
    }
  },
  watch: {
    src() {
      this.printedSrc = null
    }
  },
  methods: {
    getContainer() {
      return document.body
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    printIframe() {
      if (
        !this.autoPrint ||
        !this.visible ||
        !this.src ||
        this.printedSrc === this.src
      ) {
        return
      }

      const iframeWindow = this.$refs.iframe && this.$refs.iframe.contentWindow
      if (!iframeWindow) return

      this.printedSrc = this.src
      window.setTimeout(() => {
        try {
          iframeWindow.focus()
          iframeWindow.print()
        } catch (error) {
          this.printedSrc = null
          this.$emit('print-error', error)
        }
      }, 300)
    }
  }
}
</script>

<style>
.pdf-preview-flat-modal {
  position: fixed !important;
  inset: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
}

.pdf-preview-flat-modal .ant-modal {
  width: 100vw !important;
  max-width: 100vw !important;
  top: 0 !important;
  padding-bottom: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  height: 100vh !important;
  transform: none !important;
}

.pdf-preview-flat-modal .ant-modal-content {
  height: 100vh !important;
  min-height: 100vh !important;
  border-radius: 0;
  background: #111827;
  box-shadow: none;
  padding: 0 !important;
}

.pdf-preview-flat-modal .ant-modal-body {
  height: 100vh !important;
  min-height: 100vh !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
  background: #111827;
}

.pdf-preview-shell {
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.pdf-preview-header {
  height: 48px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
}

.pdf-preview-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.pdf-preview-close {
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 6px;
  background: #fff;
  color: #334155;
  cursor: pointer;
}

.pdf-preview-close:hover {
  background: #f1f5f9;
}

.pdf-preview-body {
  flex: 1;
  min-height: 0;
  background: #111827;
  overflow: hidden;
  position: relative;
}

.pdf-preview-flat-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

.pdf-preview-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -24px;
  margin-left: -24px;
}
</style>
